export default {
  tableView: {
    width: '100%'
  }
};
